import { MAX_ARCHIVE_PAGES } from "@root/constants"
import { graphql } from "gatsby"
import React, { useContext } from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { useTranslation } from "react-i18next"

import Button from "@atoms/Button/Button"
import CoreHeading from "@atoms/CoreHeading/CoreHeading"
import Breadcrumb from "@blocks/Breadcrumb/Breadcrumb"
import Layout from "@components/layout.js"
import SEO from "@components/seo"
import { SiteContext } from "@context/Provider"
import i18nWrapper from "@lang/i18nWrapper"
import Card from "@molecules/Card/Card"

const Tag = (props) => {
  const { t } = useTranslation()
  const {
    data: { single: page, posts },
  } = props

  const { seo, uri, name } = page

  const currentLanguage = "fi"

  // Context
  const context = useContext(SiteContext)
  context.title = `${t("Tag")}: ${name}`

  // Posts
  const categoryPosts =
    posts.edges.length > 0
      ? posts.edges.map((card, index) => {
          const { id, title, uri, featuredImage, categories } = card.node

          const tagline =
            categories?.nodes.length > 0 ? categories.nodes[0]?.name : null

          return (
            <Col key={id} md="4">
              <Card
                headingSize={"h3"}
                image={featuredImage ? featuredImage.node : false}
                imageAspectRatio={"16:9"}
                tagline={tagline}
                title={title}
                url={uri}
                internalLink={true}
              />
            </Col>
          )
        })
      : null

  // Pagination

  const currentPage = posts?.pageInfo?.currentPage || 1
  const thereAreMorePosts =
    posts?.pageInfo?.hasNextPage && MAX_ARCHIVE_PAGES > currentPage
  const nextPageNumber = thereAreMorePosts ? currentPage + 1 : false

  return (
    <Layout
      //translations={translations}
      currentLanguage={currentLanguage}
      lang={currentLanguage}
    >
      <SEO
        title={seo?.title}
        uri={uri}
        lang={currentLanguage}
        headJson={seo?.headJSON}
        //translations={translations}
      />
      <CoreHeading
        text={`${name} ${
          currentPage > 1
            ? `&ndash; ${t("Page")?.toLowerCase()} ${currentPage}`
            : ""
        }`}
        level="h1"
        align="wide"
      />
      <Breadcrumb tight wide />
      {categoryPosts && (
        <section className="base-margin-top-large base-margin-bottom-large text-align-left">
          <Row className="bottom-margins">{categoryPosts}</Row>
          {thereAreMorePosts && nextPageNumber && (
            <div className="base-margin-top-small text-center">
              <Button
                href={`${uri}${nextPageNumber}/`}
                variant="secondary"
                internalLink={true}
              >
                {t("Go to page")} {currentPage + 1}
              </Button>
            </div>
          )}
        </section>
      )}
    </Layout>
  )
}

export default i18nWrapper("Tag")(Tag)

export const query = graphql`
  query SINGLE_TAG($id: String!, $skip: Int!, $limit: Int!) {
    posts: allWpPost(
      filter: { customTags: { nodes: { elemMatch: { id: { eq: $id } } } } }
      sort: { date: DESC }
      limit: $limit
      skip: $skip
    ) {
      pageInfo {
        hasNextPage
        currentPage
      }
      edges {
        node {
          id
          title
          uri
          featuredImage {
            node {
              mediaDetails {
                width
                height
              }
              cloudinaryDetails {
                public_id
                original_filename
                format
              }
              sourceUrl
            }
          }
        }
      }
    }
    single: wpCustomTag(id: { eq: $id }) {
      id
      name
      uri
      description
      slug
      seo {
        title
        headJSON
      }
    }
  }
`
